import React from 'react'
import usePrevious from "../../hooks/usePrevious";


const CustomModal = (props) => {

    if(!props.isOpen){
        return null;
    }
    return (
        //create new solicitor group Modal does not work with the generic custom-modal className
        <div className={props.contentClassname!="solicitorGroupList-modal"?"custom-modal":"solicitorGroupList-modal"}
         style={props.modelDepth?{zIndex: props.modelDepth}:{}}>
            <div className={props.contentClassname!="solicitorGroupList-modal"?"custom-modal__content " + props.contentClassname:"appFormRefSettings-modal-content"}>
                <div className={props.contentClassname!="solicitorGroupList-modal"?"custom-modal__close-btn":"appFormRefSettings-close-button"} 
                onClick={props.handleClose}></div>
                {props.content}
            </div>
        </div>
    )
};

export default CustomModal;